import { ROUTE } from "@/route/app_routes";

// Single source of truth for "where can this role go from their dashboard" --
// consumed by both the dashboard sidebars (AdminDashboardSidebar.js /
// StudentDashboardSidebar.js, via DashboardSidebar.js) and the navbar's logged-in
// avatar dropdown (Header/Offcanvas/User.js), so the two destination lists can
// never drift out of sync with each other again.
//
// i18n: `text` is the English fallback (used if a translation is ever missing), and
// `textKey` is the react-i18next key each consumer looks up via t(textKey, text) --
// see public/locales/<lng>/common.json's "nav" block. Keeping both here (rather than
// only a key) means this file still reads fine on its own and nothing breaks if a
// consumer forgets to translate it.

export const ADMIN_NAV_ITEMS = [
  { icon: "feather-home", text: "Overview", textKey: "nav.overview", link: ROUTE.adminOverview },
  { icon: "feather-book-open", text: "Courses", textKey: "nav.courses", link: ROUTE.adminCourses },
  { icon: "feather-list", text: "Enrollments", textKey: "nav.enrollments", link: ROUTE.adminEnrollments },
  { icon: "feather-calendar", text: "Events", textKey: "nav.allEvents", link: ROUTE.adminEvents },
  { icon: "feather-tag", text: "Tickets", textKey: "nav.allTickets", link: ROUTE.adminTickets },
  { icon: "feather-users", text: "Users", textKey: "nav.users", link: ROUTE.adminUsers },
  { icon: "feather-corner-up-left", text: "Appeals", textKey: "nav.appeals", link: ROUTE.adminAppeals },
  { icon: "feather-flag", text: "Reports", textKey: "nav.reports", link: ROUTE.adminReports },
  { icon: "feather-shield", text: "Reviews & Notes", textKey: "nav.moderation", link: ROUTE.adminModeration },
  { icon: "feather-star", text: "Course Collections", textKey: "nav.courseCollections", link: ROUTE.adminCourseCollections },
  { icon: "feather-bell", text: "Notifications", textKey: "nav.notifications", link: ROUTE.notifications },
];

// Admin now has a dedicated settings page (pages/admin/settings.js /
// my_components/_AdminDashboard/AdminSettings.js) -- mirrors STUDENT_ACCOUNT_ITEMS below.
export const ADMIN_ACCOUNT_ITEMS = [
  { icon: "feather-settings", text: "Settings", textKey: "nav.settings", link: ROUTE.adminSettings },
];

export const STUDENT_NAV_ITEMS = [
  { icon: "feather-home", text: "Dashboard", textKey: "nav.dashboard", link: ROUTE.dashboard },
  { icon: "feather-book-open", text: "Enrolled Courses", textKey: "nav.enrolledCourses", link: ROUTE.enrolledCourse },
  { icon: "feather-bookmark", text: "My Wishlist", textKey: "nav.myWishlist", link: ROUTE.dashboardWishlist },
  { icon: "feather-shopping-bag", text: "Browse Courses", textKey: "nav.browseCourses", link: ROUTE.dashboardBrowseCourses },
  { icon: "feather-list", text: "Events", textKey: "nav.events", link: ROUTE.dashboardEvents },
  { icon: "feather-bell", text: "Notifications", textKey: "nav.notifications", link: ROUTE.notifications },
  { icon: "feather-user", text: "My Profile", textKey: "nav.myProfile", link: ROUTE.dashboardProfile },
  { icon: "feather-message-square", text: "My Quiz Attempts", textKey: "nav.quizAttempts", link: ROUTE.studentQuizAttempts },
  { icon: "feather-award", text: "My Certificates", textKey: "nav.myCertificates", link: ROUTE.dashboardCertificates },
];

export const STUDENT_ACCOUNT_ITEMS = [
  { icon: "feather-settings", text: "Settings", textKey: "nav.settings", link: ROUTE.dashboardSettings },
];

export function getNavItemsForRole(role) {
  return role === "admin"
    ? { navItems: ADMIN_NAV_ITEMS, accountItems: ADMIN_ACCOUNT_ITEMS }
    : { navItems: STUDENT_NAV_ITEMS, accountItems: STUDENT_ACCOUNT_ITEMS };
}
